import { combineChildrenReducers } from 'utilities/reducers'

import childProductsReducer from './childProducts'
import pageReducer from './page'
import productAdsReducer from './productAds'
import productGoalsBulkEditReducer from './productGoalsBulkEdit'

export default combineChildrenReducers(pageReducer, {
    childProducts: childProductsReducer,
    productAds: productAdsReducer,
    productGoalsBulkEdit: productGoalsBulkEditReducer,
})
